import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 -30px;
  gap: 30px;
`;

export const IconsWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const TopContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: right;
`;
